import React from 'react';
import { EntityRelatedUserProps } from './types';
import { Typography } from '../typography/typography';
import { AllPhone, AllUser } from '@vtbhome/juicyfront/indexIcon';
import {
    Wrapper,
    TooltipContent,
    AvatarWrapper,
    UserInfo,
    UserJob,
    UserLinks,
    UserName,
    UserLink,
    StyledTooltip,
    UserIcon,
} from './entity-related-user.styles';
import { Photo } from '../photo/photo';
import { Link } from '@vtbhome/juicyfront';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { CurrentUser } from '@shared/model/current-user';
import { UserPreview } from '@shared/model/user';
import { IconMail } from '@shared/icon/icon-mail/icon-mail';

export const EntityRelatedUser: React.FC<EntityRelatedUserProps> = ({
    count,
    user,
    nameType = 'full',
    tooltipProps = { position: 'top' },
}) => {
    const name = userName({ firstName: user?.firstName, lastName: user?.lastName, middleName: user?.middleName });

    return (
        <StyledTooltip {...tooltipProps} hidePadding>
            <Wrapper>
                {count ? (
                    <UserIcon>
                        <AllUser size='xxxs' />
                    </UserIcon>
                ) : (
                    <Photo photoUrl={user?.photoUrl} size='xs' name={name.full} />
                )}
                <Typography size='body2_short' color='neutral_90'>
                    {count || name[nameType] || '—'}
                </Typography>
            </Wrapper>
            {user && (
                <TooltipContent onClick={(e) => e.stopPropagation()}>
                    <AvatarWrapper>
                        <Photo photoUrl={user.photoUrl} name={name.full} size='xxxl' />
                    </AvatarWrapper>
                    <UserInfo>
                        <UserName>
                            {user.lastName && <Typography size='h6'>{user.lastName}</Typography>}
                            {(user.firstName || user.middleName) && (
                                <Typography size='h6'>
                                    {[user.firstName, user.middleName].filter(Boolean).join(' ')}
                                </Typography>
                            )}
                        </UserName>
                        <UserJob>
                            {(user as CurrentUser | UserPreview).jobTitle && (
                                <Typography size='body1_short' color='neutral_50'>
                                    {(user as CurrentUser | UserPreview).jobTitle}
                                </Typography>
                            )}
                            {(user as CurrentUser | UserPreview).department?.name && (
                                <Typography size='body1_short' color='neutral_50'>
                                    {(user as CurrentUser | UserPreview).department?.name}
                                </Typography>
                            )}
                        </UserJob>
                        <UserLinks>
                            {user.email && (
                                <UserLink>
                                    <IconMail />
                                    <Link href={`mailto:${user.email}`}>
                                        <Typography size='body1_long' color='inherit'>
                                            {user.email}
                                        </Typography>
                                    </Link>
                                </UserLink>
                            )}
                            {(user as CurrentUser | UserPreview).phoneNumber && (
                                <UserLink>
                                    <AllPhone size='xs' />
                                    <Link href={`tel:${(user as CurrentUser | UserPreview).phoneNumber}`}>
                                        <Typography size='body1_long' color='inherit'>
                                            {(user as CurrentUser | UserPreview).phoneNumber}
                                        </Typography>
                                    </Link>
                                </UserLink>
                            )}
                        </UserLinks>
                    </UserInfo>
                </TooltipContent>
            )}
        </StyledTooltip>
    );
};
